<div class="ps-password-input">
  @if (label()) {
    <label [for]="id()" class="form-label">{{ label() }}</label>
    @if (required()) {
      <span class="text-danger ms-1">*</span>
    }
  }

  <div class="input-group">
    <input
      [id]="id()"
      [name]="name()"
      [type]="type()"
      [class]="classes()"
      [placeholder]="placeholder()"
      [value]="value()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [required]="required()"
      [attr.maxlength]="maxLength()"
      [attr.minlength]="minLength()"
      [attr.aria-required]="required()"
      [attr.aria-invalid]="isInvalid()"
      [attr.aria-describedby]="isInvalid() ? ariaDescribedBy() : null"
      [attr.data-cy]="id()"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />

    <button
      type="button"
      class="password-toggle-btn"
      (click)="toggleVisibility()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-pressed]="showPassword()"
      [attr.aria-controls]="id()"
      [attr.data-cy]="id() + '-toggle-btn'"
    >
      <ps-icon [name]="iconName()" [size]="iconSize()" />
    </button>
  </div>

  @if (isInvalid() && errors().length > 0) {
    <div
      [id]="ariaDescribedBy()"
      class="invalid-feedback d-block mt-1"
      role="alert"
    >
      @for (error of errors(); track error) {
        <span class="error">{{ error.message || 'Invalid value' }}</span>
      }
    </div>
  }
</div>
